import React from 'react';
import PropTypes from 'prop-types';
import EmptyState from '../../common/EmptyState';
import ProfileTitle from '../../layout/mobile/profile/ProfileTitle';
import { Box } from '@material-ui/core';
import CardIcon from '../../common/icons/cardIcon';
import PayCardImage from '../../../assets/payCard.svg';
import { ripleyCreditCardPaymentPE } from '../../../config/paths';

const PayCard = ({ ...props }) => {
  const { mobile } = props;
  return (
    <Box>
      <ProfileTitle
        title="Pagar Tarjeta Ripley"
        mobile={mobile}
        icon={<CardIcon size="30px" color="#6A148E" />}
      />
      <EmptyState
        mobile={mobile}
        image={PayCardImage}
        onClick={() => window.open(ripleyCreditCardPaymentPE, '_blank')}
        text="Para consultar y pagar tu estado de cuenta, revisar saldo, cupos, etc.
          debes ingresar a Banco Ripley"
        buttonText="Ir a banco"
        idButton="goBankPayRipleyCard"
      />
    </Box>
  );
};

PayCard.propTypes = {
  mobile: PropTypes.bool,
};

export default PayCard;
